import { EventListenersList, EventSubscription } from "./types";

export default class EventListeners {
    /**
     * Container of event listeners
     */
    protected listeners: EventListenersList = {};

    /**
     * Get subscriptions by given event name
     *
     * @param {string} event
     * @returns {EventSubscription[]}
     */
    public get(event: string): EventSubscription[] {
        const subscriptions: EventSubscription[] = this.listeners[event] || [];

        return subscriptions;
    }

    /**
     * Set event subscription
     *
     * @param {string} event
     * @param {EventSubscription} subscriptions
     * @returns {void}
     */
    public set(event: string, subscriptions: EventSubscription[]): void {
        this.listeners[event] = subscriptions;
    }

    /**
     * Check if event in listeners container
     *
     * @param {string} event
     * @returns {boolean}
     */
    public has(event: string): boolean {
        return typeof this.listeners[event] !== "undefined";
    }

    /**
     * delete an event from the listeners container
     *
     * @param {string} event
     * @returns {void}
     */
    public delete(event: string): void {
        delete this.listeners[event];
    }

    /**
     * clear listeners container
     *
     * @returns {void}
     */
    public clear(): void {
        this.listeners = {};
    }

    /**
     * list event listeners
     *
     * @returns {EventListenersList}
     */
    public list(): EventListenersList {
        return this.listeners;
    }

    /**
     * check if container is empty
     *
     * @returns {boolean}
     */
    public isEmpty(): boolean {
        return Object.keys(this.list()).length === 0;
    }

    /**
     * get all listeners with the given namespace
     *
     * @param namespace
     * @returns {EventListenersList}
     */
    public getByNamespace(namespace: string): EventListenersList {
        let events: EventListenersList = {};

        for (const event in this.listeners) {
            if (event.startsWith(namespace)) {
                events[event] = this.listeners[event];
            }
        }

        return events;
    }

    /**
     * remove all listeners with the given namespace
     *
     * @param namespace
     * @returns {void}
     */
    public deleteByNamespace(namespace: string): void {
        for (const event in this.listeners) {
            if (event.startsWith(namespace)) {
                delete this.listeners[event];
            }
        }
    }
}
